import React from 'react'
import {useLocation, Link} from "react-router-dom"

function Page403() {

    const location = useLocation();
    console.log(location);

    // console.log("RENDER 403");

    return (
        <div className='page-403'>
            <div id="containerPanel">
                <div className="text-center py-4">
                    <h1 className='font-weight-bold'>
                        Error 403
                    </h1>

                    {location.state && location.state.hasOwnProperty("message") &&
                        <div className='alert alert-info my-3'>
                            {location.state.message}
                        </div>
                    }

                    {!location.state && 
                        <div className='alert alert-info my-3'>
                            No tiene permisos para visualizar esta página
                        </div>
                    }

                    <Link className='btn btn-primary' to="/">
                        <i className='fas fa-home mr-2'></i>Volver al inicio
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default Page403